// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadLink_container__b7qmV","name":"DownloadLink_name__V2ptp","refKey":"DownloadLink_refKey__GoL_g","content":"DownloadLink_content__xSEQj"};